<template>
  <transition name="ae-fade">
    <div
      class="non-selection block creditPosition"
      :class="creditPosition"
      v-show="showCredits"
      v-bind:style="creditPositionStyle"
    >
      <div class="block">
        <input
          name="text1"
          data-frame-action="CREDIT"
          dir="auto"
          ref="textInput"
          type="text"
          placeholder="Insert Credit text here"
          v-model="tmpAGD.creditText"
          :disabled="!primary"
        />
      </div>
      <div
        class="block positionToolbar clearfix"
        data-toggle="buttons-checkbox"
      >
        <a
          href="#"
          :class="{
            active: creditPosition == 'LOWER_LEFT',
            disabled: superPosition == 'LOWER_LEFT',
          }"
          v-on:click="changeCreditPosition('LOWER_LEFT')"
        >
          <i class="wticon wticon-super-bottom-left"></i>
        </a>
        <a
          href="#"
          :class="{
            active: creditPosition == 'LOWER_RIGHT',
            disabled: superPosition == 'LOWER_RIGHT',
          }"
          v-on:click="changeCreditPosition('LOWER_RIGHT')"
        >
          <i class="wticon wticon-super-bottom-right"></i>
        </a>
        <a
          href="#"
          :class="{
            active: creditPosition == 'UPPER_LEFT',
            disabled: superPosition == 'UPPER_LEFT',
          }"
          v-on:click="changeCreditPosition('UPPER_LEFT')"
        >
          <i class="wticon wticon-super-top-left"></i>
        </a>
        <a
          href="#"
          :class="{
            active: creditPosition == 'UPPER_RIGHT',
            disabled: superPosition == 'UPPER_RIGHT',
          }"
          v-on:click="changeCreditPosition('UPPER_RIGHT')"
        >
          <i class="wticon wticon-super-top-right"></i>
        </a>
      </div>
    </div>
  </transition>
</template>

<script>
/** (GW)
 * Asset Editor's credit stage Vue (stage bar)
 *
 */
import bus from 'v/AssetEditor/AssetEditorEventBus';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  props: {
    active: { type: Boolean, default: false },
    primary: { type: Boolean, default: false },
  },

  beforeDestroy: function () {
    bus.$off('apply', this.apply);
  },

  computed: {
    ...mapState('assetEditor', ['tmpAGD', 'stageDimensions']),

    creditPosition: function () {
      // default position, prevent collision with super position
      if (!_.isEmpty(this.tmpAGD.creditPosition)) {
        return this.tmpAGD.creditPosition;
      } else {
        if (this.superPosition === 'UPPER_RIGHT') {
          return 'LOWER_LEFT';
        } else {
          return 'UPPER_RIGHT';
        }
      }
    },

    showCredits: function () {
      return this.tmpAGD._showCredits;
    },

    creditPositionStyle: function () {
      const direction = /_LEFT/.test(this.creditPosition) ? 'left' : 'right';
      const style = {
        maxWidth: this.stageDimensions.visibleAreaWidth * 0.9 + 'px',
      };
      style[direction] =
        this.stageDimensions.curtainWidth +
        this.stageDimensions.curtainBorder +
        (direction === 'left' ? 1 : 0) +
        'px';
      return style;
    },

    superPosition: function () {
      return this.tmpAGD.superPosition;
    },
  },

  watch: {
    showCredits: function () {
      if (this.showCredits && this.primary) {
        this.focusInput();
      }
    },
  },

  mounted: function () {
    bus.$on('apply', this.apply);

    this.setTMPAGD({
      _showCredits: this.primary ? true : !_.isEmpty(this.tmpAGD.creditText),
    });

    this.track({ e: 'selectedCredit' });
  },

  methods: {
    ...mapActions('assetEditor', ['removePage', 'track']),
    ...mapMutations('assetEditor', ['setTMPAGD', 'setAGD']),

    isPositionDisabled: function (position) {
      // cannot set position where super is
      return position === this.superPosition;
    },

    focusInput: function () {
      this.$nextTick(function () {
        this.$refs.textInput.focus();
      });
    },

    changeCreditPosition: function (creditPosition) {
      this.setTMPAGD({ creditPosition });
      this.focusInput();
    },

    apply: function () {
      if (!this.active) {
        return;
      }
      if (!this.showCredits || _.isEmpty(this.tmpAGD.creditText)) {
        this.removePage('credit');
      } else {
        this.setAGD({
          creditPosition: this.creditPosition,
          creditText: this.tmpAGD.creditText,
        });
      }
    },
  },
};
</script>
